// extracted by mini-css-extract-plugin
export var arrows = "_74-6";
export var decrementer = "_74-a";
export var disabled = "_74-4";
export var error = "_74-1";
export var hiddenText = "_74-b";
export var incrementer = "_74-9";
export var input = "_74-8";
export var inputWrapper = "_74-0";
export var leadingIcon = "_74-c";
export var readonly = "_74-3";
export var regular = "_74-7";
export var small = "_74-5";
export var warning = "_74-2";